import { render, staticRenderFns } from "./TicketTypeStepper.vue?vue&type=template&id=643820bf&"
import script from "./TicketTypeStepper.vue?vue&type=script&lang=ts&"
export * from "./TicketTypeStepper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports